<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md12 sm12 lg12>
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Clients</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-select
              v-model="searchColumn"
              :items="filteredSearchColumn"
              item-text="text"
              item-value="value"
              label="Select column"
              return-object
              single-line
              hide-details
              class="mr-3"
              @input="customSearch"
            ></v-select>
            <v-text-field
              v-model="tableSearch"
              append-icon="mdi-table-search"
              label="Search..."
              single-line
              hide-details
              @input="customSearch"
            ></v-text-field>
            <v-spacer v-if="loggedUser.role === '1'"></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1'"
              @click.stop="rightDrawer = !rightDrawer"
            >New Client</v-btn>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="tableData"
              :single-expand="singleExpand"
              :expanded.sync="tableExpanded"
              :options.sync="options"
              :server-items-length="totalData"
              :loading="loading"
              item-key="name"
              class="elevation-1"
              :footer-props="{
                'items-per-page-options': [10, 15, 20, 30, 50]
              }"
              :items-per-page="15"
            >
              <template v-slot:item.status_name="{ item }">
                <v-chip :color="getStatusColor(item.status)" dark>{{ item.status_name }}</v-chip>
              </template>
              <template v-slot:item.name="{ item }">
                <a @click="goToClient(item)" dark>{{ item.name }}</a>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="$router.push({ path: 'clients/' + item.id})"
                >mdi-square-edit-outline</v-icon>
                <v-icon small @click="deleteClient(item.id)">mdi-delete</v-icon>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" v-if="item.campaigns" style="background-color: #efefef">
                  <div v-for="campaign in item.campaigns" :key="campaign.campaign_id" class="body-2"><a @click="goToCampaign(campaign)" dark>{{campaign.name}}</a></div>
                </td>
                <td v-else :colspan="headers.length" style="background-color: #efefef">
                  <div class="body-1">Nessuna campagna associata</div>
                </td>
              </template>
              <template v-slot:item.campaigns="{ item }">
                <div v-for="(campaign, index) in item.campaign_list" :key="index" class="campaign-list">
                  <div class="body-2 campaign-list-item" >{{campaign}}</div>
                  <v-divider v-if="index !== item.campaign_list.length -1"></v-divider>
                </div>

              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
        <v-navigation-drawer absolute right width="50%" v-model="rightDrawer">
          <v-flex md12 sm12 lg12 class="pa-4 mb-8">
            <h1>{{clientDetails.formTitle}}</h1>
            <v-form ref="newClient" v-model="formValid" lazy-validation style="padding-bottom:60px">
              <v-form-base :model="clientDetails.data.client" :schema="newClientSchema.client" />
              <h2>Legal Representative</h2>
              <v-form-base v-bind:value="clientDetails.data.contacts.rappresentante" v-bind:schema="newClientSchema.contacts.rappresentante" />
              <h2>Tecnical Contact</h2>
              <v-form-base :model="clientDetails.data.contacts.referente" :schema="newClientSchema.contacts.referente" />
            </v-form>
            <v-btn color="primary" @click="addClient(clientDetails.data)">Create Client</v-btn>
            <v-btn
              color="primary lighten-1"
              class="ml-4"
              outlined
              @click="rightDrawer = false"
            >Cancel</v-btn>
          </v-flex>
        </v-navigation-drawer>
      </v-flex>

      <v-dialog v-model="clientDeleteDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>Delete Client</v-card-title>
        <v-card-text>
          Do you really want to delete Client {{deletedClient.name}} ?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="secondary darken-1" outlined @click="nposDisassociateDialog = false">Cancel</v-btn>
          <v-btn color="primary darken-1" @click="disassociateNpo(disassociatedNpo.npo_id); nposDisassociateDialog = false">Disassociate Npo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-layout>
  </v-container>
</template>

<script>
import apiService from '../services'
import { mapState } from 'vuex'
import VFormBase from 'vuetify-form-base'
import { tablePaginationMixin } from '@/mixins/tablePaginationMixin'
import { statusColor } from '@/mixins/statusColor'

/**
 * Cannot decalre validation rules directly inside Data() using component vue-form-base
 * instead of placing all rules in methods wich cannot be nested for grouping
 * rules will be grouped outside of data.
 * At least it's consistent with component documentation while searching for a better solution
 *
 * https://github.com/wotamann/vuetify-form-base/blob/master/example/src/components/complex.vue
 */

// Form rules
const formRules = {
  required: field => v => (v != null && !!v && v.length > 0) || `${field} is required`,
  requiredSelect: field => v => v || `${field} is required`,
  validEmail: v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
}

// const durationOptions = ['Time', 'Budget']

// const mechanismOptions = ['Votes', 'Donations']

// const donationFactorOptions = ['%', 'Fixed']

export default {
  mixins: [tablePaginationMixin, statusColor],
  components: {
    VFormBase
  },
  computed: {
    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out action header
      return this.tableHeaders.filter(item => item.value !== 'action')
    },
    ...mapState('init', ['statuses', 'interventionAreas']),
    ...mapState({
      auth: 'auth',
      alerts: state => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    },
    newClientSchema () {
      const clientStatusOptions = this.statuses.clients

      return {
        client: {
          name: {
            type: 'text',
            label: 'Name *',
            flex: 12,
            rules: [formRules.required('Name')]
          },
          description: {
            type: 'textarea',
            label: 'Description',
            counter: 1500,
            maxlength: 1500,
            flex: 12
          },
          vat_number: {
            type: 'text',
            label: 'Vat Number *',
            flex: 12,
            counter: 11,
            mask: '############',
            maxlength: 11,
            max: 11,
            rules: [
              formRules.required('Vat Number'),
              v => (v && v.length === 11) || `Vat Number must be 11 characters long`
            ]
          },
          iban: {
            type: 'text',
            label: 'IBAN *',
            flex: 12,
            counter: 27,
            maxlength: 27,
            max: 27,
            rules: [
              v => (v && v.length === 27) || `IBAN must be 27 characters long`
            ]
          },
          fiscal_code: {
            type: 'text',
            label: 'Fiscal code *',
            flex: 12,
            counter: 11,
            mask: '############',
            maxlength: 11,
            max: 11,
            rules: [
              v => (v && v.length === 11) || `Fiscal code must be 11 characters long`
            ]
          },
          address: {
            type: 'text',
            label: 'Address *',
            flex: 12,
            rules: [formRules.required('Address')]
          },
          zip_code: {
            type: 'text',
            label: 'Zip Code *',
            flex: 6,
            mask: '#####',
            maxlength: 5,
            counter: 5,
            rules: [
              formRules.required('Zip Code'),
              v => (v && v.length === 5) || `Zip Code must be 5 characters long`
            ]
          },
          city: {
            type: 'text',
            label: 'City *',
            flex: 4,
            rules: [formRules.required('City')]
          },
          province: {
            type: 'text',
            label: 'Province *',
            flex: 2,
            maxlength: 2,
            rules: [formRules.required('Province')]
          },
          state: {
            type: 'text',
            label: 'State *',
            flex: 4,
            rules: [formRules.required('Province')]
          },
          ateco_code: {
            type: 'text',
            label: 'Ateco Code',
            flex: 12
          },
          website: {
            type: 'text',
            label: 'Website',
            flex: 12
          },
          status: {
            type: 'select',
            label: 'Status',
            clearable: false,
            items: clientStatusOptions,
            itemValue: 'id',
            itemText: 'status_name',
            flex: { xs: 12, sm: 6 }
          }
        },
        contacts: {
          referente: {
            first_name: {
              type: 'text',
              label: 'First name *',
              flex: 6,
              rules: [formRules.required('First name')]
            },
            last_name: {
              type: 'text',
              label: 'Last name *',
              flex: 6,
              rules: [formRules.required('Last name')]
            },
            email: {
              type: 'text',
              label: 'Email *',
              flex: 6,
              rules: [formRules.required('Email'), v => /.+@.+\..+/.test(v) || 'E-mail must be valid']
            },
            fiscal_code: {
              type: 'text',
              label: 'Fiscal code',
              flex: 6
            },
            phone: {
              type: 'text',
              label: 'Phone *',
              flex: 6,
              rules: [formRules.required('Phone')]
            }
          },
          rappresentante: {
            first_name: {
              type: 'text',
              label: 'First name *',
              flex: 6,
              rules: [formRules.required('First name')]
            },
            last_name: {
              type: 'text',
              label: 'Last name *',
              flex: 6,
              rules: [formRules.required('Last name')]
            },
            email: {
              type: 'text',
              label: 'Email *',
              flex: 6,
              rules: [formRules.required('Email'), v => /.+@.+\..+/.test(v) || 'E-mail must be valid']
            },
            fiscal_code: {
              type: 'text',
              label: 'Fiscal code',
              flex: 6
            },
            phone: {
              type: 'text',
              label: 'Phone *',
              flex: 6,
              rules: [formRules.required('Phone')]
            }
          }
        }
      }
    }
  },
  data () {
    return {
      clientDeleteDialog: false,
      deletedClient: {},
      tableExpanded: [],
      singleExpand: true,

      // Ricerca nella tabella
      searchColumn: '',
      tableSearch: '',
      tableSearchTimeout: false,

      // Tabella Npo
      tableHeaders: [
        {
          text: 'Client',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Contact',
          align: 'left',
          sortable: true,
          value: 'contacts'
        },
        {
          text: 'Campaigns',
          value: 'campaigns'
        },
        { text: 'Status',
          value: 'status_name',
          sortable: true
        },
        {
          text: 'City',
          align: 'left',
          sortable: true,
          value: 'city'
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      options: {},
      totalData: 0,
      tableData: [],
      loading: true,

      /**
       * New campaign form
       */
      rightDrawer: false,
      formValid: true,
      clientDetails: {
        formTitle: 'New Client',

        data: {
          client: {
            name: null
          },
          merchant: {
            name: null
          },
          contacts: {
            rappresentante: {
              first_name: null
            },
            referente: {
              first_name: null
            }
          }
        }
      }
    }
  },

  mounted () {
    this.getClientsFromApi()
  },

  methods: {
    // GET Clients
    getClientsFromApi () {
      this.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      // Setup search filter extending data-table componet option object
      // TO DO refactoring to use component and props (check if possible)
      let filter = {}
      filter.sortBy = sortBy[0] || null
      filter.page = page
      filter.limit = itemsPerPage
      filter.orderDesc = sortDesc[0] || null

      filter.search_filter = this.tableSearch !== '' ? this.searchColumn.value : ''
      filter.search_value = this.tableSearch || ''
      // GET on global entities search API endpoint

      apiService
        .fetchData('clients', filter)
        .then(data => {
          data.map(i => {
            let campaigList = []
            for (const c in i.campaigns) {
              if (i.campaigns[c].hasOwnProperty('name')) {
                campaigList.push(i.campaigns[c].name)
              }
            }
            i.campaign_list = campaigList
            return i
          })
          //  List email for contacts
          setTimeout(() => {
            this.tableData = data
            // Filter tech rep and remove null if present
            this.tableData.forEach(function (item) { item.contacts = item.contacts.map(function (x) { if (x.is_tech_rep) return x.email }).filter(x => x) })
            this.totalData = data.lenght
            this.loading = false
          }, 800)
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Error adding Client`
          })
        })
    },

    // This will trigger when either of the search inputs is changed
    customSearch () {
      if (this.searchColumn !== '') {
        // Stop timeout to prevent search from firing while user is still typing
        clearTimeout(this.tableSearchTimeout)
        // Set a timeout to fire search after the user has stopped typing
        this.tableSearchTimeout = setTimeout(() => {
          this.getClientsFromApi()
        }, 800)
      }
    },

    // Validate and submit form
    validateForm () {
      return this.$refs.newClient.validate()
    },

    addClient () {
      if (this.validateForm()) {
        let newClientData = this.clientDetails.data.client
        console.log('CLIENT', newClientData)

        // GET on global entities search API endpoint
        apiService
          .newClient(newClientData)
          .then(response => {
            if (response.status.code === 201) {
            }

            this.clientDetails.data.contacts.rappresentante.is_legal_rep = true
            apiService
              .createContact('clients', response.data.id, this.clientDetails.data.contacts.rappresentante)
              .then()
              .catch()

            this.clientDetails.data.contacts.referente.is_tech_rep = true
            apiService
              .createContact('clients', response.data.id, this.clientDetails.data.contacts.referente)
              .then()
              .catch()

            this.rightDrawer = false
            this.$store.dispatch('alert/showSnackbar', {
              color: 'success',
              text: `Client added succesfully`
            })
            setTimeout(() => {
              this.getClientsFromApi()
            }, 1500)
          })
          .catch(error => {
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: `Error adding Client ${error.message}`
            })
          })
      }
    },

    goToClient (item) {
      this.$router.push({
        path: 'clients/' + item.id,
        params: { id: item.id }
      })
    },

    goToCampaign (item) {
      this.$router.push({ path: 'campaigns/' + item.campaign_id, params: { id: item.campaign_id } })
    },

    deleteClient (clientId) {
      confirm('Do you really want to delete this client?') &&
      apiService
        .deleteClient(clientId)
        .then((response) => {
          console.log(response)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: 'Client deleted succesfully'
          })
          this.getClientsFromApi()
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: error.message
          })
        })
    }
  }
}
</script>
